<template>
	<div v-if="remainingAmount > 0" class="pt-4">
		<p class="text-ihh-midnight-gray text-center font-medium mb-2">You're ${{ remainingAmount }} away from FREE Ground Shipping!</p>
		<div class="flex flex-col items-center w-full max-w-sm mx-auto px-2">
			<div class="w-full bg-gray-200 rounded-full h-4">
				<div class="bg-ihh-dark-salmon h-4 rounded-full" :style="{ width: `${progressPercentage}%` }"></div>
			</div>
		</div>
	</div>

	<div v-else class="pt-4">
		<p class="text-ihh-midnight-gray text-center font-medium mb-2">This order qualifies for FREE Ground Shipping 🎉</p>
		<div class="flex flex-col items-center w-full max-w-sm mx-auto px-2">
			<div class="w-full bg-gray-200 rounded-full h-4">
				<div class="bg-ihh-dark-salmon h-4 rounded-full" :style="{ width: `${progressPercentage}%` }"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		currentCartTotal: {
			type: Number,
			required: true,
		},
		freeShippingThreshold: {
			type: Number,
			default: 125, // Default threshold for free shipping
		},
	},
	computed: {
		remainingAmount() {
			return Math.max(this.freeShippingThreshold - this.currentCartTotal, 0).toFixed(2)
		},
		progressPercentage() {
			const progress = (this.currentCartTotal / this.freeShippingThreshold) * 100
			return Math.min(progress, 100).toFixed(2) // Ensure it doesn't exceed 100%
		},
	},
}
</script>

<style scoped>
/* Optional: Customize styles as needed */
</style>
